import { combineReducers } from "redux";

//::::::::: VIVN USER :::::::::::
import baseAuthReducer from "./bailiff/auth/base_auth.reducer";
import loginReducer from "./user/login/login.reducer";

//::::::::: VIVN BAILIFF :::::::::::
import userAuthReducer from "./user/auth/user_auth.reducer";
import draftDialogReducer from "./bailiff/draft/dialog/draft_dialog.reducer";
import orderBailiffReducer from "./bailiff/payment/order/order_bailiff.reducer";
import navReducer from "./bailiff/nav/nav.reducer";
import draftBailiffReducer from "./bailiff/draft/bailiff/draft_bailiff.reducer";
import defaultPaperReducer from "./bailiff/(default)/paper/default_paper.reducer";
import defaultComputerReducer from "./bailiff/(default)/computer/default_computer.reducer";
import defaultDebugReducer from "./bailiff/(default)/debug/default_debug.reducer";
import bailiffDialogReducer from "./bailiff/bailiff/dialog/bailiff_dialog.reducer";
import dialogEditedReducer from "./bailiff/draft/dialog_edited/dialog_edited.reducer";

const rootReducer = combineReducers({
  //auth
  baseAuthReducer,
  userAuthReducer,

  //
  loginReducer,
  defaultPaperReducer,
  defaultComputerReducer,
  defaultDebugReducer,

  // draft
  draftBailiffReducer,
  draftDialogReducer,
  dialogEditedReducer,

  //order
  orderBailiffReducer,
  //nav
  navReducer,

  //bailiff
  bailiffDialogReducer,
});

export default rootReducer;
